<template>
  <div class="new-order-notify">
    <van-nav-bar
      title="新订单通知"
      left-text="返回"
      left-arrow
      fixed
      :placeholder="true"
      @click-left="goBack"
    />

    <div class="page-body">
      <!-- 温馨提示 + 总开关 -->
      <div class="warm-tip">
        <div class="warm-tip-row">
          <span class="warm-tip-label">温馨提示</span>
          <div class="warm-tip-switch-wrap">
            <span class="warm-tip-switch-label">总开关</span>
            <van-switch
              :value="wxNewOrderEnabled"
              size="22"
              @input="onMasterSwitchChange"
            />
          </div>
        </div>
        <p class="warm-tip-text">开启新订单推送筛选后，公众号将按您设置的条件推送符合条件的新订单，其他订单不会推送。若总开关开启，未设置任何推送条件，则不会推送新订单。如有疑问请联系客服。</p>
      </div>

      <!-- 搜索与新增 -->
      <div class="tool-bar">
        <van-field
          v-model="searchName"
          placeholder="输入规则名称搜索"
          clearable
          class="search-field"
          borderless
        />
        <van-button plain type="primary" size="small" @click="onSearch" class="search-btn">搜索</van-button>
        <van-button type="danger" size="small" @click="addRule" class="add-btn">新增规则</van-button>
      </div>

      <!-- 规则列表 -->
      <div class="rule-list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              v-for="item in list"
              :key="item.id"
              class="rule-card"
              :class="{ 'is-enabled': item.status === 1 }"
              @click="editRule(item)"
            >
              <div class="rule-main">
                <div class="rule-name">{{ item.name }}</div>
                <span class="rule-scope-tag">{{ item.scope_summary || '全国' }}</span>
              </div>
              <div class="rule-actions">
                <van-switch
                  :value="item.status === 1"
                  size="20"
                  @input="(v) => toggleStatus(item, v)"
                  @click.native.stop
                />
              </div>
            </div>
            <div v-if="list.length === 0 && !loading" class="empty-wrap">
              <van-icon name="setting-o" size="48" class="empty-icon" />
              <p class="empty-text">暂无规则</p>
              <p class="empty-hint">点击上方「新增规则」添加</p>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'

export default {
  name: 'NewOrderNotify',
  data() {
    return {
      searchName: '',
      list: [],
      page: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      finished: false,
      refreshing: false,
      wxNewOrderEnabled: false
    }
  },
  created() {
    this.loadMasterSwitch()
    // 列表由 van-list 的 @load 触发加载，避免与 created 重复请求导致数据重复
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    loadMasterSwitch() {
      const userInfo = this.$store.state.user.userInfo || {}
      this.wxNewOrderEnabled = userInfo.wx_new_order_type === 1
    },
    onMasterSwitchChange(enabled) {
      this.wxNewOrderEnabled = enabled
      Api.setAutoStatus({ wx_new_order_type: enabled ? 1 : 2 }).then(() => {
        this.$toast.success(enabled ? '已开启' : '已关闭')
        const userInfo = { ...this.$store.state.user.userInfo }
        userInfo.wx_new_order_type = enabled ? 1 : 2
        this.$store.commit('setUserInfo', userInfo)
      }).catch(() => {
        this.wxNewOrderEnabled = !enabled
        this.$toast.fail('设置失败')
      })
    },
    loadList(isRefresh = false) {
      if (isRefresh) {
        this.page = 1
        this.list = []
        this.finished = false
      }
      const page = this.page
      Api.getOrderNotifyConditionList({
        page,
        pageSize: this.pageSize,
        name: this.searchName || undefined
      }).then((res) => {
        // 后端返回 success: false 时也走 then，需在此处拦截，避免误用错误数据并防止重复请求
        if (res && res.success === false) {
          this.loading = false
          this.refreshing = false
          this.finished = true
          this.$toast.fail(res.msg || '查询失败')
          return
        }
        const arr = (res && res.list) || []
        this.total = (res && res.total) != null ? res.total : 0
        if (isRefresh) {
          this.list = arr
        } else {
          this.list.push(...arr)
        }
        if (!isRefresh) this.page += 1
        this.loading = false
        this.refreshing = false
        if (this.list.length >= this.total) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.refreshing = false
        this.finished = true
        this.$toast.fail('加载失败')
      })
    },
    onLoad() {
      if (this.finished) return
      this.loading = true
      this.loadList()
    },
    onRefresh() {
      this.page = 1
      this.list = []
      this.finished = false
      this.loadList(true)
    },
    onSearch() {
      this.page = 1
      this.list = []
      this.finished = false
      this.loadList(true)
    },
    addRule() {
      this.$router.push('/new-order-notify/rule')
    },
    editRule(item) {
      this.$router.push(`/new-order-notify/rule/${item.id}`)
    },
    toggleStatus(item, enabled) {
      Api.updateOrderNotifyConditionStatus({
        id: item.id,
        status: enabled ? 1 : 2
      }).then(() => {
        item.status = enabled ? 1 : 2
        this.$toast.success(enabled ? '已启用' : '已停用')
      }).catch(() => {
        this.$toast.fail('操作失败')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.new-order-notify {
  background: #f0f2f5;
  min-height: 100vh;
  padding-bottom: 24px;
}

.page-body {
  padding: 12px 16px 0;
}

.warm-tip {
  margin-bottom: 12px;
  padding: 12px 14px;
  background: linear-gradient(135deg, #fff8f6 0%, #fff5f5 100%);
  border-radius: 10px;
  border: 1px solid rgba(255, 100, 80, 0.12);

  .warm-tip-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }

  .warm-tip-label {
    font-size: 12px;
    font-weight: 600;
    color: #ee0a24;
    letter-spacing: 0.5px;
  }

  .warm-tip-switch-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .warm-tip-switch-label {
    font-size: 13px;
    color: #323233;
  }

  .warm-tip-text {
    margin: 0;
    font-size: 13px;
    color: #646566;
    line-height: 1.55;
  }
}

.tool-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 10px 14px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  .search-field {
    flex: 1;
    min-width: 0;
    padding: 6px 0;
    background: transparent !important;
  }

  .search-field ::v-deep .van-field__body {
    background: #f5f6f7;
    border-radius: 8px;
    padding: 6px 12px;
  }

  .search-btn {
    flex-shrink: 0;
  }

  .add-btn {
    flex-shrink: 0;
    border-radius: 8px;
  }
}

.rule-list {
  padding: 0;
}

.rule-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border-left: 3px solid transparent;
  transition: box-shadow 0.2s;

  &.is-enabled {
    border-left-color: #07c160;
  }

  .rule-main {
    flex: 1;
    min-width: 0;
  }

  .rule-name {
    font-size: 15px;
    font-weight: 600;
    color: #323233;
    margin-bottom: 6px;
  }

  .rule-scope-tag {
    display: inline-block;
    font-size: 12px;
    color: #969799;
    background: #f2f3f5;
    padding: 2px 8px;
    border-radius: 4px;
  }

  .rule-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
}

.empty-wrap {
  text-align: center;
  padding: 48px 24px;

  .empty-icon {
    color: #dcdee0;
    margin-bottom: 12px;
  }

  .empty-text {
    margin: 0 0 4px;
    font-size: 15px;
    color: #969799;
  }

  .empty-hint {
    margin: 0;
    font-size: 13px;
    color: #c8c9cc;
  }
}
</style>
